import { useEffect, useState } from "react";
import type { ModelInputs, Snapshot } from "@/engine/types";
import { useDatos } from "./store/store";

type ComputeFn = (i: ModelInputs) => Snapshot;
let motor: Promise<ComputeFn> | null = null;
/** El motor (~19 KB gz) se carga una sola vez y solo donde se captura. */
export const cargarMotor = () => (motor ??= import("@/engine").then((m) => m.compute));

/** Corre compute() sobre los inputs del formulario con un debounce corto: la foto se arma mientras el miembro llena. */
export function useFotoEnVivo(inputsExternos?: ModelInputs, espera = 150): { snapshot: Snapshot | null; error: string | null } {
  const delStore = useDatos((s) => s.inputs);
  const inputs = inputsExternos ?? delStore;
  const [res, setRes] = useState<{ snapshot: Snapshot | null; error: string | null }>({ snapshot: null, error: null });
  useEffect(() => {
    let vivo = true;
    const t = setTimeout(() => {
      cargarMotor().then((compute) => {
        if (!vivo) return;
        try { setRes({ snapshot: compute(inputs), error: null }); }
        catch (e) { setRes((r) => ({ snapshot: r.snapshot, error: (e as Error).message })); }
      });
    }, res.snapshot ? espera : 0);
    return () => { vivo = false; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputs, espera]);
  return res;
}
